import React from "react";
import { cn } from "../lib/helpers";
import Container from "./container";
import ProjectItem from "./project-item";
import Icon from "./icon";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";

import * as styles from "../styles/components/fc-projects.module.css";

interface ImageAsset {
  asset?: {
    _id?: string;
  };
  alt?: string;
}

interface Project {
  title?: string;
  location?: string;
  _rawCopy?: any[];
  image?: ImageAsset;
}

interface ProjectItem {
  _key?: string;
  project?: Project;
}

interface ProjectsProps {
  projects?: ProjectItem[];
  theme?: string;
}

const Projects: React.FC<ProjectsProps> = ({
  projects,
  theme
}) => {
  if (!projects || projects.length === 0) {
    return null;
  }

  const PrevArrow: React.FC<any> = (props) => {
    const { className, style, onClick } = props;
    return (
      <button
        type="button"
        className={cn(className, styles.arrow, styles.prev)}
        style={{ ...style }}
        onClick={onClick}
      >
        <span className="sr-only">Previous</span>
        <Icon symbol="chevron-left-shape" />
      </button>
    );
  };

  const NextArrow: React.FC<any> = (props) => {
    const { className, style, onClick } = props;
    return (
      <button
        type="button"
        className={cn(className, styles.arrow, styles.next)}
        style={{ ...style }}
        onClick={onClick}
      >
        <span className="sr-only">Next</span>
        <Icon symbol="chevron-right-shape" />
      </button>
    );
  };

  const settings = {
    infinite: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    slidesToShow: 4,
    swipeToSlide: true,
    touchThreshold: 15,
    responsive: [
      {
        breakpoint: 1599,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          swipeToSlide: false,
        }
      },
    ]
  };

  return (
    <div className={cn(styles.root, styles[theme])}>
      <Container>
        <h2 className={cn("h3", styles.title)}>Notable Projects</h2>

        <Slider {...settings} className={styles.items}>
          {projects.map(({_key, project}) => (
            <ProjectItem project={project} theme={theme} key={_key} />
          ))}
        </Slider>
      </Container>
    </div>
  );
};

export default Projects;
